// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yssFmTm4I_yx1uTo_viB {
    margin-top: 16px;
    text-align: right;
}

.qVIfLHjPqfCXoQGdbX2E + .qVIfLHjPqfCXoQGdbX2E {
    margin-left: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/interests-profile-slideout/components/actions.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".confirmationFooter {\n    margin-top: 16px;\n    text-align: right;\n}\n\n.confirmationButton + .confirmationButton {\n    margin-left: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"confirmationFooter": `yssFmTm4I_yx1uTo_viB`,
	"confirmationButton": `qVIfLHjPqfCXoQGdbX2E`
};
export default ___CSS_LOADER_EXPORT___;
